import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { css } from 'design'

import { useNavAndClearSelected } from '../../hooks/app_location/use_nav_and_clear_selected'
import { getCurrentAccount } from '../../reduxes/slices/current/selectors'
import { getRoutes } from '../../reduxes/slices/routes/selectors'
import { useSelectorDelegateStore } from '../../reduxes/stores/root_store/hooks'
import { Timestamp } from '../timekeeping/timestamp'
import { UpgradePromptButton } from './upgrade_prompt_button'

export const TimelinesUpgradePrompt = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement>,
) => {
  const account = useSelector(getCurrentAccount)
  const routes: any = useSelectorDelegateStore(getRoutes)
  const navAndClearSelected = useNavAndClearSelected()

  const goToPlans = useCallback(() => {
    navAndClearSelected(routes.admin_app_billing.path)
  }, [routes.admin_app_billing.path, navAndClearSelected])

  return (
    <UpgradePromptButton
      className={upgradePromptStyles()}
      onClick={goToPlans}
      {...props}
    >
      <span>
        Upgrade to view messages prior to&nbsp;
        <Timestamp date={account.timelines_limit_at} timeStyle={3} />
      </span>
      <div>
        View plans&nbsp;
        <i className="fas fa-chevron-right" />
      </div>
    </UpgradePromptButton>
  )
}
const upgradePromptStyles = css({
  margin: '$4',
  padding: '$4',
})
